/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import Header from "../headers/light.js";

import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/dot-pattern.svg";
import DesignIllustration from "../../images/design-illustration.svg";

const Container = styled.div`
  ${tw`relative`}
  background: linear-gradient(135deg, #FDFAF6 0%, #F0FAF9 60%, #E8F8F7 100%);
`;

const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-16 md:py-20 px-8`;
const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-16 flex-shrink-0 text-center lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`;

const Heading = styled.h1`
  ${tw`font-black text-3xl md:text-5xl leading-snug max-w-3xl`}
  font-family: 'Cormorant Garant', serif;
  color: #0C2A29;
  line-height: 1.2;
`;

const Paragraph = tw.p`my-5 lg:my-8 text-base lg:text-lg font-medium leading-relaxed max-w-lg mx-auto lg:mx-0`;

const Actions = tw.div`flex flex-col items-center sm:flex-row justify-center lg:justify-start mt-8 gap-4`;

const BookButton = styled.a`
  ${tw`font-bold px-8 py-4 rounded-lg text-white text-center transition duration-300 focus:outline-none focus:shadow-outline no-underline`}
  background-color: #2A9D8F;
  font-family: 'Nunito', sans-serif;
  font-size: 1rem;
  min-width: 200px;
  &:hover {
    background-color: #1B6158;
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(42, 157, 143, 0.35);
  }
  &:active {
    transform: translateY(0);
  }
`;

const CallButton = styled.a`
  ${tw`font-bold px-8 py-4 rounded-lg text-center transition duration-300 focus:outline-none no-underline`}
  border: 2px solid #2A9D8F;
  color: #1B6158;
  font-family: 'Nunito', sans-serif;
  font-size: 1rem;
  min-width: 200px;
  background-color: transparent;
  &:hover {
    background-color: #E0F5F3;
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
`;

const StatsRow = styled.div`
  ${tw`flex flex-wrap justify-center lg:justify-start mt-10 gap-8`}
  padding-top: 1.5rem;
  border-top: 1px solid rgba(42, 157, 143, 0.2);
`;

const Stat = tw.div`text-center lg:text-left`;

const StatNumber = styled.div`
  font-family: 'Cormorant Garant', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #2A9D8F;
  line-height: 1;
`;

const StatLabel = tw.div`text-sm text-gray-600 mt-1 font-medium`;

const IllustrationContainer = styled.div`
  ${tw`flex justify-center md:justify-end items-center relative max-w-3xl lg:max-w-none`}
`;

const HeroImage = styled.img`
  ${tw`rounded-2xl`}
  max-height: 540px;
  width: 100%;
  object-fit: cover;
  object-position: center top;
  box-shadow: 0 20px 60px rgba(12, 42, 41, 0.15);
`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none fill-current text-primary-500 opacity-15 absolute w-32 h-32 right-0 bottom-0 transform translate-x-10 translate-y-10 -z-10`}
`;

export default ({
  heading = "Modern React Templates, Just For You",
  description = "Our templates are easy to setup, understand and customize.",
  imageSrc = DesignIllustration,
  imageCss = null,
  imageDecoratorBlob = false,
}) => {
  return (
    <>
      <Header />
      <Container>
        <TwoColumn>
          <LeftColumn>
            <Heading>{heading}</Heading>
            <Paragraph css={tw`text-secondary-400`}>{description}</Paragraph>
            <Actions>
              <BookButton href="https://wa.me/+919815662600" target="_blank" rel="noopener noreferrer">
                Book Appointment
              </BookButton>
              <CallButton href="tel:+919815662600">
                Call: +91-98156-62600
              </CallButton>
            </Actions>
            <StatsRow>
              <Stat>
                <StatNumber>15+</StatNumber>
                <StatLabel>Years Experience</StatLabel>
              </Stat>
              <Stat>
                <StatNumber>Est. 2008</StatNumber>
                <StatLabel>Serving Ludhiana</StatLabel>
              </Stat>
              <Stat>
                <StatNumber>4–8 PM</StatNumber>
                <StatLabel>Mon – Sat Clinic</StatLabel>
              </Stat>
            </StatsRow>
          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              <HeroImage css={imageCss} src={imageSrc} alt="Dr. Seema Kaushal — Gynaecologist in Ludhiana" />
              {imageDecoratorBlob && <DecoratorBlob2 />}
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
        <DecoratorBlob1 />
      </Container>
    </>
  );
};
